import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/shadcn/button'
import { Languages } from 'lucide-react'
import type { PlannedLanguages } from './types'
import { TranslationsDialog } from './TranslationsDialog'

interface TranslateButtonProps {
  dialogTitle?: string
  value: Record<string, string>
  onChange: (translations: Record<string, string>) => void
  plannedLanguages?: PlannedLanguages
  onPlannedChange?: (planned: PlannedLanguages) => void
  autoTranslateAll?: boolean
  /** The original source text shown read-only on the right side of the dialog */
  sourceValue?: string
  /** When true, renders RichTextEditor fields in the dialog */
  isRichText?: boolean
}

export function TranslateButton({
                                  dialogTitle,
                                  value,
                                  onChange,
                                  plannedLanguages,
                                  onPlannedChange,
                                  autoTranslateAll,
                                  sourceValue,
                                  isRichText,
                                }: TranslateButtonProps) {
  const { t } = useTranslation('common')
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="icon"
        title={t('translations.editTranslations')}
        onClick={() => setOpen(true)}
      >
        <Languages className="text-primary" />
      </Button>
      <TranslationsDialog
        open={open}
        onOpenChange={setOpen}
        title={dialogTitle}
        value={value}
        onApply={onChange}
        plannedLanguages={plannedLanguages}
        onPlannedChange={onPlannedChange}
        autoTranslateAll={autoTranslateAll}
        sourceValue={sourceValue}
        isRichText={isRichText}
      />
    </>
  )
}
